export default __webpack_public_path__ + "static/media/slim.d110da88.svg";